<template>
  <div class="select-eidt">
    <div class="select-eidt-content">
      <div class="content-icon">
        <slot>
          <i class="iconfont icon-bianji1" @click.stop="$emit('goEdit')"></i>
          <i class="iconfont icon-a-shanchu2x" v-if="isAppenDel" @click.stop="$emit('goDel')"></i>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'selectEdit',
  // 组件参数 接收来自父组件的数据
  props: {
    isAppenDel: {
      type: Boolean,
      default: false,
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
      return {}
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {},
}
</script>

<style scoped lang="scss">
.select-eidt {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  inset: 0;
  .select-eidt-content {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: none;
    ::v-deep .content-icon {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 14px;
        color: #fff;
        cursor: pointer;
        &:hover {
          color: #4e86ff;
        }
      }
      .icon-a-shanchu2x {
        margin-left: 10px;
      }
      .icon-shaixuan2 {
        margin-left: 10px;
      }
    }
  }
  &:hover {
    .select-eidt-content {
      display: block;
    }
  }
}
</style>
